import serverEpics from "./serverEpics";
import rccEpics from "./rccEpics";
import helperEpics from "./helperEpics";
import moduleEpics from "./moduleEpics";
import licenseEpics from "./licenseEpics";
import loginEpics from "./loginEpics";
import settingsEpics from "./settingsEpics";
import globalEpics from "./globalEpics";
import navigationEpics from "./navigationEpics";
import searchPanelEpics from "./searchPanelEpics";
import filteringEpics from "./filteringEpics";
import mainTabEpics from "./mainTabEpics";
import favoritesTabEpics from "./favoritesTabEpics";
import customTabEpics from "./customTabEpics";
import formulaEpics from "./formulaEpics";
import spectroEpics from "./spectroEpics";
import matchingEpics from "./matchingEpics";
import statisticsTabEpics from "./statisticsTabEpics";
import barcodeEpics from "./barcodeEpics";
import virtualKeyboardEpics from "./virtualKeyboardEpics";
import pricingEpics from "./pricingEpics";
import orderingEpics from "./orderingEpics";
import customersEpics from "./customersEpics";
import intergammaOrderEpics from "./intergammaOrderEpics";
import intergammaSettingsEpics from "./intergammaSettingsEpics";
import intergammaMachineEpics from "./intergammaMachineEpics";
import importDataEpics from "./importDataEpics";

const epics = [
    ...serverEpics,
    ...rccEpics,
    ...helperEpics,
    ...moduleEpics,
    ...licenseEpics,
    ...loginEpics,
    ...settingsEpics,
    ...globalEpics,
    ...navigationEpics,
    ...searchPanelEpics,
    ...filteringEpics,
    ...mainTabEpics,
    ...favoritesTabEpics,
    ...customTabEpics,
    ...formulaEpics,
    ...spectroEpics,
    ...matchingEpics,
    ...statisticsTabEpics,
    ...barcodeEpics,
    ...virtualKeyboardEpics,
    ...pricingEpics,
    ...orderingEpics,
    ...customersEpics,
    ...importDataEpics,
    ...intergammaOrderEpics,
    ...intergammaSettingsEpics,
    ...intergammaMachineEpics
];

export default epics;
